<div class="d-flex justify-content-center align-items-center h-100 overlay">
  <div class="spinner-border text-success" style="width: 3rem; height: 3rem;" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>